import script from "./PlaceBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaceBadge.vue?vue&type=script&setup=true&lang=js"

import "./PlaceBadge.vue?vue&type=style&index=0&id=8f9f4e1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f9f4e1a"]])

export default __exports__